export default __webpack_public_path__ + "static/media/equalswap-logo.8484d5e0.png";